import { createContext, useCallback, useMemo, useState } from "react";
import "./App.css";
import Onboarding from "./components/Onboarding";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import { SnackbarProvider } from "notistack";
import SideBar from "./components/panel/SideBar";
import Dashboard from "./components/panel/dashboard/Dashboard";
import Pendings from "./components/panel/pendings_transaction/Pendings";
import Fallback from "./components/utility/Fallback";
import Friends from "./components/panel/dashboard/Friends";
import { ThemeProvider, createTheme } from "@mui/material";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import VerifyEmail from "./components/auth/VerifyEmail";
import Home from "./components/panel/home/Home";
import AddHome from "./components/panel/home/AddHome";
import HomeBoard from "./components/panel/home/HomeBoard";
import About from "./components/About";
import ErrorBoundary from "./components/utility/ErrorBoundary";
export const AppContext = createContext(null);

function App() {
  const [state, setState] = useState({
    session: null,
    database: {},
    mode:'light',
    viewCards:false,
    banner:true
  });
  
const setMode=useCallback((mode)=>{
  setState(prev=>{
    prev.mode=mode
    return {...prev}
  })
},[state])
const hideBanner=useCallback(()=>{
  setState(prev=>{
    prev.banner=false
    return {...prev}
  })
},[state])
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Onboarding />,
      children: [
        {
          path: "login",
          element: <Login />,
        },
        {
          path: "signup",
          element: <Signup />,
        },
        {
          path: "verify_email",
          element: <VerifyEmail />,
        },
        {
          path: "forget",
          element: <ForgotPassword />,
        },
        {
          path: "reset/:id/:otp",
          element: <ResetPassword />,
        },
        {
          path: "panel",
          element: <SideBar mode={state.mode} setMode={setMode} banner={state.banner} hideBanner={hideBanner}/>,
          children: [
            {
              path: "",
              element: <Dashboard />,
            },
            {
              path: "friends",
              element: <Friends />,
            },
            {
              path: "transactions",
              element: <Pendings />,
            },
               {
          path: "about",
          element: <About />,
        },
            {
              path:'*',
              element:<Fallback title={'No such page found.'}/>
            }
          ],
        },
        {
          path: "home",
          element: <SideBar mode={state.mode} setMode={setMode} banner={state.banner} hideBanner={hideBanner}/>,
          children: [
            {
              path: "",
              element: <Home />,
            },
            {
              path:"add",
              element:<AddHome/>
            },{
              path:"dashboard",
              element:<HomeBoard/>
            },
            {
              path:'*',
              element:<Fallback title={'No such page found.'}/>
            }
          ],
        },
     
        {
          path:'*',
          element:<Fallback fullScreen title={'Outside Route Detect.'}/>
        }
      ],
    },
  ]);
  const getDesignTokens = (mode) => ({
    palette: {
      mode
    },
  });
  const theme = useMemo(() => createTheme(getDesignTokens(state.mode)), [state]);
  return (
    <ThemeProvider theme={theme}>
    <AppContext.Provider value={{ state, setState }}>
      <SnackbarProvider autoHideDuration={3000} maxSnack={2}>
       <ErrorBoundary>
        <RouterProvider router={router} />
        </ErrorBoundary>
      </SnackbarProvider>
    </AppContext.Provider>
    </ThemeProvider>
  );
}

export default App;
